import * as React from "react";
export const CELL_SEP = /* @__PURE__ */ React.createElement(React.Fragment, null, "\u200B");
export const INFINITE_SCROLL_DIRECTION_UP = "UP";
export const INFINITE_SCROLL_DIRECTION_DOWN = "DOWN";
